const initialState = {
  data: {
    cuentadepredial: null,
    curt: null,
    clavecatastral: null,
    description: null,
    total: null,
    extra: null,
    cargos: [],
    ref: null,
  },
};

const mutations = {
  SET_DATA(state, payload) {
    state.data = {
      ...state.data,
      ...payload,
    };
  },
  CLEAR_DATA(state) {
    state.data = {
      propertyKey: null,
      description: null,
      total: null,
      cargos: [],
      ref: null,
      extra: null,
    };
  },
};

const actions = {
  SET_DATA({ commit }, payload) {
    if (typeof payload === 'object') {
      commit('SET_DATA', payload);
    }
  },
  CLEAR_DATA({ commit }) {
    commit('CLEAR_DATA');
  },
};

export default {
  state: initialState,
  mutations,
  actions,
  namespaced: true,
};
